import { createFileRoute } from '@tanstack/react-router'
import { Lightbulb } from 'lucide-react'
import { z } from 'zod'
import { SkillsScreen } from '@/screens/improve/SCR-033-skills'

export const Route = createFileRoute('/_app/w/$ws/skills')({
  staticData: { screen: {"id":"SCR-033","title":"Skills & strategies","group":"Improve","perm":"learning.read","order":4,"description":"Reusable strategies learned from what worked.", icon: Lightbulb } },
  validateSearch: z.object({ status: z.enum(['draft', 'probation', 'active', 'archived']).optional(), s: z.string().max(200).optional() }),
  component: SkillsScreen,
})
